export default __webpack_public_path__ + "static/media/deer2.c4db04f6.png";